"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var MembershipTree1Icon = /*#__PURE__*/function (_React$Component) {
  function MembershipTree1Icon() {
    _classCallCheck(this, MembershipTree1Icon);
    return _callSuper(this, MembershipTree1Icon, arguments);
  }
  _inherits(MembershipTree1Icon, _React$Component);
  return _createClass(MembershipTree1Icon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "membership-tree2-icon icon"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 199 199",
        version: "1.1",
        xmlns: "https://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval-3",
        fill: "#3BCBEB",
        cx: "105.5",
        cy: "95.5",
        r: "85.5"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M99.5,178 C142.854353,178 178,142.854353 178,99.5 C178,56.1456471 142.854353,21 99.5,21 C56.1456471,21 21,56.1456471 21,99.5 C21,142.854353 56.1456471,178 99.5,178 Z M99.5,199 C44.5476674,199 0,154.452333 0,99.5 C0,44.5476674 44.5476674,0 99.5,0 C154.452333,0 199,44.5476674 199,99.5 C199,154.452333 154.452333,199 99.5,199 Z",
        id: "Oval",
        fill: "#FFFFFF"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M40.9571388,150.663556 C52.9037669,134.659798 75.0013666,123.917034 100.286336,123.917034 C125.571305,123.917034 147.668904,134.659798 159.615532,150.663556 C145.778306,167.85122 124.345533,178.882353 100.286336,178.882353 C76.2271386,178.882353 54.7943654,167.85122 40.9571429,150.66355 Z",
        id: "Combined-Shape",
        fill: "#596A04"
      }), /*#__PURE__*/_react["default"].createElement("ellipse", {
        id: "Oval-4",
        fill: "#2DA355",
        cx: "136.511628",
        cy: "78",
        rx: "44.5116279",
        ry: "44"
      }), /*#__PURE__*/_react["default"].createElement("ellipse", {
        id: "Oval-3",
        fill: "#138343",
        cx: "65",
        cy: "78",
        rx: "45",
        ry: "44"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval-4",
        fill: "#4F9D2A",
        cx: "80.5",
        cy: "46.5",
        r: "27.5"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval-4",
        fill: "#48B549",
        cx: "120.5",
        cy: "46.5",
        r: "27.5"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval-4",
        fill: "#A4D546",
        cx: "103",
        cy: "25",
        r: "23"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M109.860732,132.947466 L97.4190726,132.947466 C103.916954,114.42047 104.506147,100.620306 99.1866496,91.5469753 C91.2074038,77.9369786 55.2859972,81.7610673 45.4798395,84.7503617 C41.0019583,86.1153924 41.0019583,85.1189609 45.4798395,81.7610673 C57.5699646,75.1783117 73.0309685,73.9612941 91.8628513,78.1100145 C110.694734,82.2587349 116.694028,100.537885 109.860732,132.947466 Z",
        id: "Path-2",
        fill: "#8F7623"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M110.679954,99.4500717 C121.250089,85.5777616 129.86849,78.6416066 136.535156,78.6416066 C143.201823,78.6416066 147.740885,78.9749399 150.152344,79.6416066 C155.167969,79.6416066 155.167969,78.4101596 150.152344,75.9472656 C139.918993,70.9222372 124.610938,75.9933938 120.619141,79.6416066 C115.362895,84.4454332 110.930324,89.2771827 107.321429,94.1368552 L110.679954,99.4500717 Z",
        id: "Path-3",
        fill: "#8F7623"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M94.680257,86.6250329 C93.9921203,78.7425074 95.4438059,71.1206346 99.0353138,63.7594146 C102.626822,56.3981946 110.441941,50.6767949 122.480672,46.5952156 L121.373047,48.9179688 C112.789335,51.451046 106.597517,56.3981946 102.797592,63.7594146 C98.9976674,71.1206346 98.1680538,79.1662309 100.308751,87.8962035 L94.680257,86.6250329 Z",
        id: "Path-4",
        fill: "#8F7623"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M72.1659713,86.0298173 C71.4778346,78.1472918 72.9295202,70.5254191 76.5210281,63.164199 C80.112536,55.802979 87.9276555,50.0815794 99.9663865,46 L98.8587612,48.3227532 C90.2750492,50.8558304 84.0832309,55.802979 80.2833063,63.164199 C76.4833817,70.5254191 75.6537681,78.5710153 77.7944656,87.3009879 L72.1659713,86.0298173 Z",
        id: "Path-4",
        fill: "#8F7623",
        transform: "translate(85.983193, 66.650494) scale(-1, 1) translate(-85.983193, -66.650494) "
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M95.1659713,81.1307547 C91.5744634,66.1732256 91.5744634,53.3243022 95.1659713,42.5839844 C96.5961592,38.3070419 100.808479,34.2769133 100.794466,35.5615234 C100.778889,36.9894553 96.5961592,39.9833984 95.9199219,47.5839844 C95.3912623,53.525866 94.9226096,55.1544122 95.1659713,61.6289063 C95.5351798,71.4514792 97.4113561,78.5703252 100.7945,82.985444 L95.1659713,81.1307547 Z",
        id: "Path-4",
        fill: "#8F7623"
      }))));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _icon_wrapper["default"])(MembershipTree1Icon);